export var QuillToolbarFormatType;
(function (QuillToolbarFormatType) {
    QuillToolbarFormatType["SIZE"] = "size";
    QuillToolbarFormatType["BOLD"] = "bold";
    QuillToolbarFormatType["ITALIC"] = "italic";
    QuillToolbarFormatType["UNDERLINE"] = "underline";
    QuillToolbarFormatType["DATE_EMBED"] = "dateEmbed";
    QuillToolbarFormatType["LINK"] = "link";
    QuillToolbarFormatType["TARGET_LINK"] = "targetLink";
    QuillToolbarFormatType["BULLET"] = "bullet";
    QuillToolbarFormatType["LIST"] = "list";
    QuillToolbarFormatType["INDENT"] = "indent";
    QuillToolbarFormatType["YCNICON"] = "ycnIcon";
    QuillToolbarFormatType["IMAGE"] = "image";
})(QuillToolbarFormatType || (QuillToolbarFormatType = {}));
export const BASE_TOOLBAR_FORMATS = [
    QuillToolbarFormatType.BOLD,
    QuillToolbarFormatType.ITALIC,
    QuillToolbarFormatType.UNDERLINE,
];
export const BULLET_POINT_TOOLBAR_FORMATS = [
    QuillToolbarFormatType.BULLET,
    QuillToolbarFormatType.LIST,
    QuillToolbarFormatType.INDENT,
];
export const ICON_LIST = [
    'icon-1-2',
    'icon-1-3',
    'icon-1-4',
    'icon-add-circle',
    'icon-add-left',
    'icon-add-right',
    'icon-add',
    'icon-ai-a',
    'icon-ai-q',
    'icon-alert',
    'icon-apple-color',
    'icon-arrow-up-right',
    'icon-auth-app',
    'icon-auth-email',
    'icon-back',
    'icon-benefit-1-color',
    'icon-benefit-2-color',
    'icon-benefit-3-color',
    'icon-bird',
    'icon-blank',
    'icon-briefcase',
    'icon-browse',
    'icon-calendar-event-add',
    'icon-calendar-event',
    'icon-calendar',
    'icon-change-type',
    'icon-chart-bars',
    'icon-chart-candlestick',
    'icon-chart-line',
    'icon-chart-ohlc',
    'icon-charts',
    'icon-chat-small',
    'icon-chat',
    'icon-check-rich-color',
    'icon-check',
    'icon-close-arrow',
    'icon-close-circle',
    'icon-close',
    'icon-collapse',
    'icon-condense',
    'icon-contact-color',
    'icon-copy',
    'icon-csv',
    'icon-dark-mode',
    'icon-dashboard',
    'icon-data-color',
    'icon-delete',
    'icon-disable',
    'icon-dollar-cost-averaging',
    'icon-dots-more',
    'icon-down-arrow',
    'icon-download-small',
    'icon-download',
    'icon-draft-color',
    'icon-drag',
    'icon-duplicate',
    'icon-edit-module',
    'icon-edit',
    'icon-email-modules',
    'icon-embed',
    'icon-esg-carbon',
    'icon-esg-carbon3',
    'icon-esg-environmental',
    'icon-esg-female',
    'icon-esg-firearms',
    'icon-esg-fossil',
    'icon-esg-governance',
    'icon-esg-independence',
    'icon-esg-performance',
    'icon-esg-rights',
    'icon-esg-social',
    'icon-esg-tobacco',
    'icon-esg-warming',
    'icon-esg-weapons',
    'icon-excel',
    'icon-expand-content',
    'icon-expand-full',
    'icon-expand',
    'icon-export',
    'icon-file',
    'icon-filter-bars',
    'icon-filter',
    'icon-folder-add',
    'icon-folder-move',
    'icon-folder',
    'icon-friend',
    'icon-gain',
    'icon-gear-outline',
    'icon-gear',
    'icon-go',
    'icon-google-color',
    'icon-hamburger',
    'icon-info',
    'icon-key-outline',
    'icon-left-arrow',
    'icon-lightbulb',
    'icon-link',
    'icon-list',
    'icon-lock',
    'icon-loss',
    'icon-magnify',
    'icon-mail',
    'icon-modify',
    'icon-module-chart-area-color',
    'icon-module-chart-bar-color',
    'icon-module-chart-column-color',
    'icon-module-chart-line-color',
    'icon-module-chart-pie-color',
    'icon-module-chart-scatter-color',
    'icon-module-chart-stacked-color',
    'icon-module-email-calendar',
    'icon-module-email-chart',
    'icon-module-email-commentary',
    'icon-module-email-review',
    'icon-module-email-summary',
    'icon-module-heatmap-color',
    'icon-module-image-color',
    'icon-module-landscape-eighth-color',
    'icon-module-landscape-full-color',
    'icon-module-landscape-half-color',
    'icon-module-landscape-multicomp-eighth-color',
    'icon-module-landscape-multicomp-full-color',
    'icon-module-landscape-multicomp-half-color',
    'icon-module-landscape-multicomp-quarter-horizontal-color',
    'icon-module-landscape-multicomp-quarter-vertical-color',
    'icon-module-landscape-quarter-horizontal-color',
    'icon-module-landscape-quarter-square-color',
    'icon-module-landscape-sixteenth-color',
    'icon-module-portrait-eighth-horizontal-color',
    'icon-module-portrait-eighth-vertical-color',
    'icon-module-portrait-full-color',
    'icon-module-portrait-half-color',
    'icon-module-portrait-multicomp-full-color',
    'icon-module-portrait-multicomp-half-color',
    'icon-module-portrait-multicomp-quarter-horizontal-color',
    'icon-module-portrait-multicomp-quarter-vertical-color',
    'icon-module-portrait-multicomp-sixteenth-color',
    'icon-module-portrait-quarter-horizontal-color',
    'icon-module-portrait-quarter-vertical-color',
    'icon-module-portrait-sixteenth-color',
    'icon-module-proposal-color',
    'icon-module-stress-test-color',
    'icon-module-table-color',
    'icon-module-tear-sheet-color',
    'icon-module-text-color',
    'icon-more',
    'icon-move',
    'icon-my-ycharts',
    'icon-new',
    'icon-newspaper',
    'icon-notes-add',
    'icon-notes',
    'icon-notification',
    'icon-open-arrow',
    'icon-open-new-window',
    'icon-open',
    'icon-outlook-color',
    'icon-overview-chart',
    'icon-overview',
    'icon-password-no-show',
    'icon-password-show',
    'icon-pendo',
    'icon-phone',
    'icon-pin-big',
    'icon-pin-filled',
    'icon-pin',
    'icon-portfolio-type-blended',
    'icon-portfolio-type-client',
    'icon-portfolio-type-household',
    'icon-portfolio-type-model',
    'icon-preview-medium',
    'icon-preview-small',
    'icon-preview',
    'icon-print',
    'icon-pulling-down-index',
    'icon-pulling-up-index',
    'icon-quick-chart-color',
    'icon-quickflows',
    'icon-remove-circle',
    'icon-reorder-leftright',
    'icon-reorder-up',
    'icon-report',
    'icon-reset-zoom',
    'icon-reset',
    'icon-resources-color',
    'icon-retirement-withdrawals',
    'icon-return',
    'icon-right-arrow',
    'icon-save',
    'icon-search',
    'icon-send',
    'icon-shape-circle',
    'icon-shape-cross',
    'icon-shape-diamond',
    'icon-shape-triangle',
    'icon-share',
    'icon-shrink-content',
    'icon-soon',
    'icon-sparkle',
    'icon-square',
    'icon-star',
    'icon-subscription-color',
    'icon-substract',
    'icon-team',
    'icon-template-alerts-color',
    'icon-template-benchmark-portfolio-color',
    'icon-template-chart-color',
    'icon-template-client-portfolio-color',
    'icon-template-comp-color',
    'icon-template-custom-text-color',
    'icon-template-economic-indicator-list-color',
    'icon-template-heatmap-color',
    'icon-template-household-portfolio-color',
    'icon-template-model-portfolio-color',
    'icon-template-multicomp-color',
    'icon-template-news-ai-color',
    'icon-template-news-color',
    'icon-template-overview-color',
    'icon-template-presentation-color',
    'icon-template-proposal-color',
    'icon-template-scatterplot-color',
    'icon-template-security-list-color',
    'icon-template-stress-test-color',
    'icon-template-tearsheet-color',
    'icon-template-tech-chart-color',
    'icon-template',
    'icon-thumb-down-active',
    'icon-thumb-down',
    'icon-thumb-up-active',
    'icon-thumb-up',
    'icon-tier-analyst',
    'icon-tier-enterprise',
    'icon-tier-presenter',
    'icon-tier-professional',
    'icon-tool-adv-fibonacci',
    'icon-tool-adv-parallel-channel',
    'icon-tool-adv-pitchfork',
    'icon-tool-arrow-line',
    'icon-tool-arrow-ray',
    'icon-tool-arrow-segment',
    'icon-tool-circle-outline',
    'icon-tool-circle',
    'icon-tool-counter-arrow',
    'icon-tool-counter-label',
    'icon-tool-counter-vertical',
    'icon-tool-crooked-3',
    'icon-tool-crooked-5',
    'icon-tool-crooked-elliot-3',
    'icon-tool-crooked-elliot-5',
    'icon-tool-crosshair',
    'icon-tool-cursor',
    'icon-tool-dragger',
    'icon-tool-flag-circle',
    'icon-tool-flag-diamond',
    'icon-tool-flag-simple',
    'icon-tool-flag-square',
    'icon-tool-horizontal-line',
    'icon-tool-line-color',
    'icon-tool-line',
    'icon-tool-measure-x',
    'icon-tool-measure-xy',
    'icon-tool-measure-y',
    'icon-tool-parallel-channel',
    'icon-tool-ray',
    'icon-tool-rectangle-outline',
    'icon-tool-rectangle',
    'icon-tool-text-color',
    'icon-tool-text',
    'icon-tool-trend-segment',
    'icon-tool-vertical-line',
    'icon-tools-color',
    'icon-tp-donut-chart-color',
    'icon-tp-number-chart-color',
    'icon-tp-number-text-color',
    'icon-tp-range-color',
    'icon-tweet',
    'icon-uneditable',
    'icon-update',
    'icon-upload',
    'icon-user',
    'icon-video',
    'icon-warning-octagon',
    'icon-warning-triangle',
    'icon-warning',
    'icon-workflows',
    'icon-y-logo-sm',
    'icon-y-logo',
    'icon-zoom-x',
    'icon-zoom-y',
    'icon-zoom',
];
